import Badge from '@repo/ui/badge'
import Typography from '@repo/ui/typography'

import { TeflAverageRating as TeflAverageRatingType } from '../../../../lib/types/models/tefl/tefl'
import { formatReviewNumber } from '../centers/center-tab-views/center-end-of-stay-appreciations/review-rating-pill'

/** The youths' "prof étr." / "enc étr." average on its own scale (x/5 or x/3), "-" when the backend sends none. */
const TeflAverageRating: React.FC<TeflAverageRatingType> = ({
  averageRating,
  averageRatingScaleMax
}) =>
  averageRating === null ||
  averageRating === undefined ||
  averageRatingScaleMax === null ||
  averageRatingScaleMax === undefined ? (
    <Typography variant="text">-</Typography>
  ) : (
    <Badge text={`${formatReviewNumber(averageRating)} / ${averageRatingScaleMax}`} />
  )

export default TeflAverageRating
